'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCardTilesPropFactory = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _svgFetcher = require('acq-components/lib/utils/svgFetcher');

var _svgFetcher2 = _interopRequireDefault(_svgFetcher);

var _MatchHeight = require('acq-components/lib/utils/MatchHeight');

var _Link = require('acq-components/lib/base-components/Link/Link');

var _getCardImage = require('acq-components/lib/utils/getCardImage');

var _getCardImage2 = _interopRequireDefault(_getCardImage);

var _Sanitizer = require('acq-components/lib/base-components/Sanitizer/Sanitizer');

var _dtmConsts = require('acq-components/lib/utils/DTM/dtmConsts');

var _lodash = require('lodash.get');

var _lodash2 = _interopRequireDefault(_lodash);

var _componentHelpers = require('../../utils/component-helpers');

var _dtmEvent = require('acq-components/lib/utils/DTM/dtmEvent');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCardTilesPropFactory = exports.getCardTilesPropFactory = function getCardTilesPropFactory(cards, intlPage, TitleTag, cardProductStyles, dtmHelper, openModal) {
  var reduceFeaturesToTileModel = function reduceFeaturesToTileModel(acc, _ref, outerIndex) {
    var desc = _ref.desc,
        assets = _ref.assets;

    desc.forEach(function (content, subIndex) {
      var asset = assets[subIndex] || {};
      var uniqueKey = '' + content.type + (outerIndex + 1) + '_' + (subIndex + 1);

      acc.push({
        key: uniqueKey,
        icon: (0, _svgFetcher2.default)(asset.url, 'dls', { wrapper: 'div' }),
        iconColor: asset.color,
        styles: cardProductStyles,
        children: content.text
      });
    });

    return acc;
  };

  var reduceCardTileLinks = function reduceCardTileLinks(card) {
    return function (acc, linkKey) {
      var cardLinksArray = card.links;
      var getLinkByKey = function getLinkByKey(cardLink) {
        return cardLink.key && cardLink.key === linkKey;
      };
      var link = !!cardLinksArray && cardLinksArray.filter(getLinkByKey)[0];
      if (link && (0, _keys2.default)(link).length) {
        if (linkKey === 'learnMore' || linkKey === 'speakToSpecialist') {
          var cardTileLinkModel = {
            children: link.title,
            link: link.url,
            dtm: link.dtm,
            styles: cardProductStyles,
            hoverText: link.hoverText,
            component: _Link.Link,
            hide: link.hide
          };

          acc.push(cardTileLinkModel);
        } else if (linkKey === 'compare') {
          var _cardTileLinkModel = {
            children: link.title,
            dtm: link.dtm,
            hoverText: link.hoverText,
            styles: cardProductStyles,
            component: 'button',
            onClick: (0, _componentHelpers.getCompareButtonOnClickHandler)({
              dtmHelper: dtmHelper,
              cardShortName: (0, _lodash2.default)(card, 'shortName'),
              compareLink: link,
              section: _dtmConsts.DTM_CONSTS.middle
            }),
            hide: link.hide
          };

          acc.push(_cardTileLinkModel);
        } else if (linkKey === 'modal') {
          var _cardTileLinkModel2 = {
            children: link.title,
            dtm: link.dtm,
            hoverText: link.hoverText,
            styles: cardProductStyles,
            component: 'button',
            onClick: function onClick() {
              openModal((0, _lodash2.default)(card, 'shortName'));
            },
            hide: link.hide
          };

          acc.push(_cardTileLinkModel2);
        }
      }

      return acc;
    };
  };

  var mapContentToTileModel = function mapContentToTileModel(desc) {
    var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return {
      Component: _Sanitizer.Sanitizer,
      componentProps: {
        Component: props.Component || 'div',
        safelySetInnerHTML: desc.text,
        className: props.className || cardProductStyles.productDescription
      }
    };
  };

  var getAnnualFee = function getAnnualFee(card) {
    var annualFeeProps = { className: cardProductStyles.annualFee };
    var cardAnnualFeeInline = (0, _lodash2.default)(card, 'annualFeeInline', []);
    var annualFeeInline = (cardAnnualFeeInline || []).map(function (annualFee) {
      var labels = (0, _lodash2.default)(intlPage, 'page.cardTiles.labels') || [];
      var annualFeeLabel = (labels.filter(function (label) {
        return label.identifier === 'annualFee';
      })[0] || {}).text;
      var annualFeeObject = !annualFeeLabel ? annualFee : (0, _assign2.default)({}, annualFee, {
        text: annualFeeLabel + ' ' + annualFee.text
      });

      return mapContentToTileModel(annualFeeObject, annualFeeProps);
    });

    return annualFeeInline;
  };

  var getSuppAnnualFee = function getSuppAnnualFee(card) {
    return (card.suppAnnualFee || []).map(mapContentToTileModel);
  };

  var getProductLinks = function getProductLinks(card, intlPage) {
    return ((0, _lodash2.default)(intlPage, 'page.cardTiles.sectionLinks') || []).reduce(reduceCardTileLinks(card), []);
  };

  var getCardDetails = function getCardDetails(card) {
    return ((0, _lodash2.default)(card, 'links') || []).find(function (_ref2) {
      var _ref2$key = _ref2.key,
          key = _ref2$key === undefined ? '' : _ref2$key;
      return key.toLowerCase() === 'learnmore';
    }) || {};
  };

  var getFeatureContent = function getFeatureContent(card) {
    return (0, _lodash2.default)(card, 'cardFeatures.content') || (0, _lodash2.default)(card, 'productFeatures.content') || [];
  };

  var getproductWelcomeOffer = function getproductWelcomeOffer(card) {
    return (0, _lodash2.default)(card, 'cardProductWelcomeOffer') || null;
  };

  var getDescription = function getDescription(card) {
    return ((0, _lodash2.default)(card, 'desc') || []).map(mapContentToTileModel);
  };

  var mapToCardModel = function mapToCardModel(card) {
    var description = getDescription(card);
    var featureContent = getFeatureContent(card);
    var productWelcomeOffer = getproductWelcomeOffer(card);
    var annualFeeInline = getAnnualFee(card, intlPage, cardProductStyles);
    var suppAnnualFee = getSuppAnnualFee(card);
    var cardDetails = getCardDetails(card);
    var productLinks = getProductLinks(card, intlPage);
    var cardImage = (0, _getCardImage2.default)(card, 'tile');
    var cardTitle = card.cardTitle || card.productHeadline;

    var cardProductTile = {
      productType: 'card',
      ImageComponent: _Link.Link,
      imageComponentProps: {
        className: cardProductStyles.productImageContainer,
        href: cardDetails.url || '#',
        dtm: cardDetails.dtm,
        children: _react2.default.createElement('img', {
          className: cardProductStyles.productImage,
          src: cardImage.url,
          alt: cardImage.alt
        })
      },
      TitleComponent: _Link.Link,
      titleComponentProps: {
        href: cardDetails.url || '#',
        dtm: cardDetails.dtm,
        className: cardProductStyles.productTitle,
        children: _react2.default.createElement(
          _MatchHeight.MatchHeight,
          { name: 'Card Title', key: '_match-height' },
          _react2.default.createElement(_Sanitizer.Sanitizer, { safelySetInnerHTML: cardTitle, Component: TitleTag })
        )
      },
      productFeatures: featureContent ? featureContent.reduce(reduceFeaturesToTileModel, []) : [],
      productDescription: [].concat((0, _toConsumableArray3.default)(description)),
      productFootnotes: [].concat((0, _toConsumableArray3.default)(annualFeeInline), (0, _toConsumableArray3.default)(suppAnnualFee)),
      productWelcomeOffer: productWelcomeOffer,
      productLinks: productLinks,
      className: card.shortName + '-tile'
    };

    return cardProductTile;
  };

  return {
    products: cards.map(mapToCardModel)
  };
};